module.exports = __webpack_public_path__ + "img/invoice2.bc01e814.png";